import {
  GET_TRANSACTION_DATA_LOADING,
  GET_TRANSACTION_DATA_SUCCESS,
  GET_TRANSACTION_DATA_FAILED,  
  GET_TRANSACTION_DATA_REMOVE
} from "../types/index";



const initialState: PaymentGatewayTransactionState = {
  transactionData: null,
  loading: null,
  error: null,
};

interface PaymentGatewayTransactionState {
  transactionData: TransactionData | null;
  loading: boolean | null;
  error: any; 
}

interface Payer {
  firstName: string;
  lastName: string;
  email: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  address: string;
  phone: string;
}

interface Payment {
  amount: string;
  method: string;
  payer: Payer;
  cardType: string;
  type: string;
  description: string;
  status: string;
  merchantOrderId: string;
  currencyName: string;
  currencyCode: string;
  merchantId: string;
  merchantName: string;
}

interface Transaction {
  amount: string;
  creationDate: string;
  type: string;
  currencyName: string;
  currencyCode: string;
  action: string;
  status: string;
  payment: Payment;
  sortRelevance: string;
}

interface TransactionData {
  totalMatchedCount: string;
  currentMatchedCount: string;
  searchOffset: string;
  transactions: Transaction[];
}

const paymentGatewayTransactionReducer = (state = initialState , action : { type: any; loading: any; payload: any; error: any }) => {
  switch (action.type) {
    case GET_TRANSACTION_DATA_LOADING:
      return { ...state, loading: true};
    case GET_TRANSACTION_DATA_SUCCESS:
      return { ...state, transactionData: action.payload, loading: false };
    case GET_TRANSACTION_DATA_FAILED:
      return { ...state, error: action.error, loading: false ,transactionData:null };
    case GET_TRANSACTION_DATA_REMOVE :
      return { ...state, error: null, loading: false , transactionData:null }; 
    default:
      return state;
  }
};

export default paymentGatewayTransactionReducer;
